import { callAsync } from './call-async.js';
import { showModal } from '../core/bootstrap-helpers.js';
import { displayToastrAlert } from '../ui/toastr-alert.js';
import { formatCurrency } from '../core/utilities.js';

export function asyncPostOnload() {
    if (!$('.async-post-onload').length) {
        return;
    }
    var requests = {};
    var elements = {};
    $('.async-post-onload').each(function(k, asp) {
        if ($(this).attr('async-url') === undefined || $(this).attr('async-url') === false) {
            return;
        }
        var aspurl = $(this).attr('async-url');
        if (!requests.hasOwnProperty(aspurl)) {
            requests[aspurl] = {};
            elements[aspurl] = [];
        }
        // The response is read back below by each element's position within its own URL group,
        // so the POST fields have to be keyed the same way. The loop index k counts every
        // .async-post-onload element on the page, including ones skipped above, so it diverges
        // from that position as soon as a page has async elements pointing at two URLs.
        var aspindex = elements[aspurl].length;
        elements[aspurl].push($(this));
        $.each(asp.attributes, function(ak, attr){
            if (attr.name.substring(0, 11) == 'async-post-') {
                // strip the whole 'async-post-' prefix: the controllers read $_POST['aaia'] etc.
                var postfield = attr.name.substring(11) + '[' + aspindex + ']';
                requests[aspurl][postfield] = attr.value;
            }
        });
    });
    $.each(requests, function(f_url, f_postData){  
        callAsync({
            url: f_url,
            postData: f_postData,
            callback: function(response){
                var c = 0;
                while(c < elements[f_url].length) {
                    var $element = elements[f_url][c]; 
                    var response_chunk = response[c] ?? response;
                    c++;
                    // these skip one element - a return here would drop every element
                    // still queued behind it for this URL
                    if ($element.attr('async-url') != f_url) {
                        continue;
                    }
                    if ($element.attr('async-target-id') !== undefined && response_chunk.hasOwnProperty('html')) {
                        $('#' + $element.attr('async-target-id')).html(response_chunk.html);
                    }
                    if ($element.attr('async-callback') === undefined || $element.attr('async-callback') === false) {
                        console.log('async-post-onload #' + c + ' has no callback');
                        continue;
                    }
                    var callback = {function: $element.attr('async-callback')};
                    window[callback.function](response_chunk, $element);
                }
            }
        });
    });
}

export function kitBuilderTableTotals() {
    totalCharges($('#kit-items'), $('#add_kit_items_button'));
}

export function totalCharges($group_container, $submit_button = null) {
    var $total = $('#' + $group_container.attr('total_container_id'));
    var total = 0;
    var are_valid_items = false;
    $group_container.find('.subtotal-elements').each(function() {
        var unit_price = $(this).find('.unit-price-input').val();
        var qty = $(this).find('.quantity-input').val();
        var no_aaia = ($(this).find('.aaia-hidden').val() == '');
        var inv = parseFloat($(this).find('.quantity-input').attr('available_inventory'));
        var $sub = $(this).find('.subtotal-display');
        var subtotal = (unit_price * qty);
        var subtotal_formatted = formatCurrency(subtotal);
        total += parseFloat(subtotal);
        if (subtotal == 0) {
            $sub.html('');
        } else {
            $sub.html('$' + subtotal_formatted);
            are_valid_items = true;
        }
        if (qty > inv || no_aaia) {
            if (no_aaia) {
                $(this).addClass('alert alert-default');
            } else {
                $(this).addClass('alert alert-danger');
            }
        } else {
            $(this).removeClass('alert alert-danger');
            $(this).removeClass('alert alert-default');
            $(this).addClass('kit-item-row');
        }
    });
    if (are_valid_items) {
        if ($submit_button != null) {
            $submit_button.removeAttr('disabled');
        }
        $total.html('$' + formatCurrency(total));
    } else {
        if ($submit_button != null) {
            $submit_button.attr('disabled', 'disabled');
        }
        $total.html('$' + formatCurrency(0.00));
    }
}

export function displayResponseMessage(response, $element) {
    var message = '';
    var type = '';
    if (response.hasOwnProperty('success') && response.success != null && response.success !== false) {
        message = response.success;
        type = 'success';
    } else if (response.hasOwnProperty('error') && response.error != null && response.error !== false) {
        message = response.error;
        type = 'error';
    } else if ($element.attr('async-success-message')) {
        message = $element.attr('async-success-message');
        type = 'success';
    } else {
        message = 'Operation successful';
        type = 'success';
    }
    var container_id = $element.attr('async-message-id');
    if (container_id != null) {
        var $container = $('#' + container_id);
        $container.html(message);
        $container.removeClass('d-none');
    } else {
        displayToastrAlert(type, message);
    }
}

export function loadAltKitBuilderItemsModal(e) {
    var $row = $(e.target).closest('.kit-item-row');
    var $modal = $(document.documentElement).find('.alt-items-modal');
    $modal.find('.item-title').html($row.find('.item-title').text().trim());
    $modal.find('.alts-for').attr('kit-item-row-id', $row.attr('id'));
}

export function getAltKitBuilderItems(ignore_size = false) {
    var $modal = $(document.documentElement).find('.alt-items-modal');
    var cpostData = {};
    var $altsfor = $modal.find('.alts-for');
    var $row = $('#' + $altsfor.attr('kit-item-row-id'));
    cpostData.kit_id = $row.find('.kit-hidden').val();
    cpostData.component_id = $row.find('.component-hidden').val();
    cpostData.key_id = $row.find('.key-hidden').val();
    cpostData.qty = $row.find('.quantity-input').val();
    if (!ignore_size) {
        cpostData.size = $row.find('.size-input').val();
    }
    var $c_target = $modal.find('.kit-modal-results');
    $c_target.html('<div class="modal-body"><span class="loading"><i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading Alternate Parts...</span></div>');
    showModal($modal);
    callAsync(
        {
            url: 'kit-builder/ajaxGetAltItemsModalContent',
            $target: $c_target,
            postData: cpostData
        }
    );
}
